import * as React from 'react'

function IconCircleTime({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={105}
      viewBox="0 0 104 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#prefix__filter4_circle)">
            <path
              d="M52 103.01c28.167 0 51-22.836 51-51.005C103 23.835 80.167 1 52 1 23.834 1 1 23.836 1 52.005c0 28.17 22.834 51.005 51 51.005z"
              fill="#fff"
            />
            <path
              d="M52 103.01c28.167 0 51-22.836 51-51.005C103 23.835 80.167 1 52 1 23.834 1 1 23.836 1 52.005c0 28.17 22.834 51.005 51 51.005z"
              stroke={'#A3A3A3'}
              strokeWidth={2}
              strokeMiterlimit={10}
            />
            <path
              d="M52 95.86c24.219 0 43.852-19.634 43.852-43.855C95.852 27.784 76.219 8.149 52 8.149 27.782 8.15 8.15 27.784 8.15 52.005 8.149 76.225 27.782 95.86 52 95.86z"
              fill={'#A3A3A3'}
            />
            <path
              d="M51.929 70.625c10.325 0 18.696-8.37 18.696-18.696 0-10.326-8.37-18.696-18.696-18.696-10.326 0-18.697 8.37-18.697 18.696 0 10.325 8.371 18.696 18.697 18.696z"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
            <path
              d="M51.929 41.836v7.314c0 1.78.705 3.489 1.966 4.75l4.283 4.282"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="prefix__filter4_circle"
              x={0}
              y={0}
              width={104}
              height={104.01}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M52 103.01c28.167 0 51-22.836 51-51.005C103 23.835 80.167 1 52 1 23.834 1 1 23.836 1 52.005c0 28.17 22.834 51.005 51 51.005z"
            fill="#fff"
          />
          <path
            d="M52 103.01c28.167 0 51-22.836 51-51.005C103 23.835 80.167 1 52 1 23.834 1 1 23.836 1 52.005c0 28.17 22.834 51.005 51 51.005z"
            stroke={'#A3A3A3'}
            strokeWidth={2}
            strokeMiterlimit={10}
          />
          <path
            d="M52 95.86c24.219 0 43.852-19.634 43.852-43.855C95.852 27.784 76.219 8.149 52 8.149 27.782 8.15 8.15 27.784 8.15 52.005 8.149 76.225 27.782 95.86 52 95.86z"
            stroke={'#A3A3A3'}
            strokeWidth={0.75}
            strokeMiterlimit={10}
          />
          <path
            d="M51.929 70.625c10.325 0 18.696-8.37 18.696-18.696 0-10.326-8.37-18.696-18.696-18.696-10.326 0-18.696 8.37-18.696 18.696 0 10.325 8.37 18.696 18.696 18.696z"
            stroke="#A2A2A2"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M51.929 41.836v7.314c0 1.78.705 3.489 1.966 4.75l4.283 4.282"
            stroke="#A2A2A2"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconCircleTime
